import { HydrogenRequest } from '@shopify/hydrogen';
import { PossibleParamKey } from '../hooks/url/useUrlParams';
import { ACCESSORY_FILTER_KEYS, possibleFilterKeys } from '@lib/home-wizard/models/generic-models';

type PresetNames = 'configuratorParams' | 'filterParams';

export const getRootUrlFromApiRequest = (request: HydrogenRequest, appendToUrl?: string) => {
    const url = new URL(request.normalizedUrl);
    const port = url.port;
    const newUrl = new URL(`${url.protocol}//${url.hostname}${port ? `:${port}` : ``}${appendToUrl ?? ``}`);
    url.searchParams.forEach((val, key) => newUrl.searchParams.append(key, val));
    return newUrl.toString();
};

/**
 * A list of params used to check and verify the UTMs.
 * Needed to keep the UTMs in the url when automatically redirecting
 * The list of these params comes from https://ga-dev-tools.web.app/campaign-url-builder/
 */
export const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content'] as const;

// a list of presets to be used to clean unwanted params
/**
 * @deprecated
 */
export const presetParams: Record<PresetNames, PossibleParamKey[]> = {
    configuratorParams: [...ACCESSORY_FILTER_KEYS],
    filterParams: ['page', 'sort', 'search', 'base_product', ...possibleFilterKeys],
};
